import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("head", null, [
  /*#__PURE__*/_createElementVNode("title", null, "portifolio")
], -1)
const _hoisted_2 = { class: "home" }
const _hoisted_3 = {
  class: "banner",
  id: "sobre"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "sobre" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
    /*#__PURE__*/_createElementVNode("strong", null, [
      /*#__PURE__*/_createElementVNode("h2", null, "Olá, eu sou")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("h1", null, "Lucas Hideo"),
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
    /*#__PURE__*/_createElementVNode("strong", null, [
      /*#__PURE__*/_createElementVNode("h2", null, "Desenvolvedor back-end")
    ])
  ])
], -1)
const _hoisted_5 = { class: "img" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  class: "linguagem",
  id: "tec"
}
const _hoisted_8 = {
  class: "projeto",
  id: "projeto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Linguagem = _resolveComponent("Linguagem")!
  const _component_Projeto = _resolveComponent("Projeto")!

  return (_openBlock(), _createElementBlock("html", null, [
    _hoisted_1,
    _createElementVNode("body", null, [
      _createVNode(_component_Header),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _ctx.foto,
              alt: "",
              class: "foto"
            }, null, 8, _hoisted_6)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Linguagem)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Projeto)
        ])
      ])
    ])
  ]))
}